import React from 'react';
import PropTypes from 'prop-types';
import { Container } from './styled';

const CLFontIcon = ({ icon, ...rest }) => (
  <Container icon={icon} {...rest} />
);

CLFontIcon.propTypes = {
  icon: PropTypes.string.isRequired,
};

export default CLFontIcon;
